export const taskStatusesEnum = {
  1: {
    className: "assigned",
    fill: "var(--system-yellow-warning, #FC9403)",
    text: "Assigned",
  },
  2: {
    className: "accepted",
    fill: "#3B81FE",
    text: "Accepted",
  },
  3: {
    className: "completed",
    fill: "var(--system-green-sucess, #0E9349)",
    text: "Completed",
  },
  4: {
    className: "onHold",
    fill: "#D46600",
    text: "On hold",
  },
  5: {
    className: "archived",
    fill: "#045B46",
    text: "Archived",
  },
  default: {
    className: "noStatus",
    fill: "#555555",
    text: "No Status",
  },
};

export const getTaskStatus = (type) => taskStatusesEnum[type] || "Unknown Type";

export const taskTypes = {
  1: "Ops preparation",
  2: "Data Collection",
  3: "Data check",
  4: "Translation",
  5: "Field report",
  6: "Data cleaning",
  7: "Data analysis",
  8: "Data translation",
  9: "IP report",
  10: "Donor report",
  11: "Other",
};

export const getTaskTypes = (type) => taskTypes[type] || "Unknown Type";
